import { SET_EXPERIMENTS } from '../actions/set-experiments';

// TODO: move to 'site' folder
export default function experiments(state = {}, action) {
  switch (action.type) {
    case SET_EXPERIMENTS:
      return action.payload;
    default:
      return state;
  }
}
